import Vue from 'vue';
import {Video} from "./VideoSection";
import {tabsFn} from "./TabsSection";
import {showMoreFn} from "./ImageTextShowMoreSection";
import {ServicesFn} from "./ServicesSection";
import {GetActiveJobs} from "./activeJobListSection";
import {Homepage} from "../homepage/homepage";

import Swiper from "swiper";
import 'swiper/swiper-bundle.min.css';
const $ = window.jQuery;
const $window = window.$window || $(window);
const heroSectionSection = document.querySelectorAll('.tabs-wrap');

(function () {
    if (!heroSectionSection || !heroSectionSection.length) {
        return false
    }
})();

let ids = [...heroSectionSection].map(el => el.id);
if (ids && ids.length) {
    ids.forEach(el => {
        const HeroVie = new Vue({
            el: `#${el}`,
            data() {
                return {
                    activeTab: 1,
                    loading: false,
                    perma: ''
                }
            },
            watch: {
                loading(v) {
                    if(!document.getElementById('loader')) return
                    v ? document.getElementById('loader').classList.remove('hidden') : document.getElementById('loader').classList.add('hidden')
                }
            },
            mounted() {
                if(document) {
                    const tabs = document.getElementsByClassName('tab')
                    if (tabs && tabs.length) {
                        tabs[0].click()
                    }
                }
            },
            methods: {
                getContent(perma) {
                    if(this.perma === perma) return false
                    $('#conntentGetter').html(null)
                    this.perma = perma
                    this.loading = true
                    const $that = this
                    $.ajax({
                        url: `${perma}`,
                        type: 'GET',
                        success: function (data) {
                            $('#conntentGetter').html($(data).find('.page-section'));
                            if (tabsFn) tabsFn()
                            if (showMoreFn) showMoreFn()
                            if (ServicesFn) ServicesFn()
                            if (Video) Video()
                            if(GetActiveJobs) GetActiveJobs()
                            if(Homepage) Homepage()
                            setTimeout(() => {
                                $that.loading = false
                            }, 20)
                        }
                    });
                }
            }
        })
    })
}